export default __webpack_public_path__ + "static/media/faz_2.967336db.png";